import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { Navigate } from "react-router";
import { JSX } from "react";

const DraftRoute = ({
  checkForDraft,
  children,
}: {
  checkForDraft: boolean;
  children: JSX.Element;
}) => {
  const event = useSelector((state: RootState) => state.event);
  return (
    <>
      {checkForDraft && event.status === "draft" ? (
        <Navigate to={"/"} />
      ) : (
        children
      )}
    </>
  );
};

export default DraftRoute;
